<div class="pl-pane__container--horizontal">
  @if (displayHeader) {
    <header class="pl-page-header pl-pane--shrink">
      <h1 class="pl-heading--xlarge">
        {{ 'REGISTRATIONS.registrations' | translate }}
      </h1>
    </header>
  }
  @if (loaded) {
    <div class="pl-pane--collapse">
      <div class="pl-pane--shrink pl-pane--condense-bottom">
        <div pl-grid="tight fixed">
          <div pl-grid-el pl-grid="1/1@phone 1/2@tablet 1/3@desktop">
            <div class="pl-field-group">
              <div class="pl-search-field pl-field-group__item--expand">
                <input
                  id="registration_search"
                  name="registration_search"
                  [(ngModel)]="searchTerm"
                  (ngModelChange)="search($event)"
                  placeholder="{{ 'REGISTRATIONS.search_placeholder' | translate }}"
                  class="pl-search-field__input"
                  attr.aria-label="{{ 'REGISTRATIONS.search_placeholder' | translate }}" />
              </div>
            </div>
          </div>
        </div>
      </div>
      @if (!surveyResults?.length && !filtered) {
        <div >
          <se-fe-empty-state seFeDataTitle="{{ 'REGISTRATIONS.EMPTY.header' | translate }}">
            <se-fe-icon seFeEmptyStateIcon seFeDataName="question_thin" seFeDataSize="950" seFeDataColor="gray-900"></se-fe-icon>
            {{ 'REGISTRATIONS.EMPTY.message' | translate }}
          </se-fe-empty-state>
        </div>
      }
      @if (!surveyResults?.length && filtered) {
        <div >
          <se-fe-empty-state seFeDataTitle="{{ 'REGISTRATIONS.NO_RESULTS.header' | translate }}">
            <se-fe-icon seFeEmptyStateIcon seFeDataName="question_thin" seFeDataSize="950" seFeDataColor="gray-900"></se-fe-icon>
            {{ 'REGISTRATIONS.NO_RESULTS.message' | translate }}
          </se-fe-empty-state>
        </div>
      }
      <div class="pl-pane pl-pane--collapse-top">
        @if (surveyResults && surveyResults.length) {
          <div id="action-links-container"
            pl-grid="tight fixed align-center"
            >
            <div pl-grid-el pl-grid="1/1@phone">
              <div class="pl-list-grid" style="margin-top: 1px;">
                <se-fe-list>
                  @for (sr of surveyResults; track sr) {
                    <se-fe-list-item>
                      <se-fe-header size="600">
                        <a [routerLink]="buildRouterLinks(sr).routerLink" [queryParams]="buildRouterLinks(sr).routerLinkQueryParams"  class="pl-link" seFeHeaderTitle>{{ sr.survey_name }}</a>
                        <div seFeHeaderSubtitle>{{ 'REGISTRATIONS.details' | translate: {
                          id: sr.id,
                          persona: getPersonaNameById(sr.persona_id),
                          date: (sr.placed_at | date),
                          site: sr.site_name
                        } }}</div>
                        <div seFeHeaderActions>
                          @if (sr.actionLinks && sr.actionLinks.params) {
                            <a [routerLink]="sr.actionLinks.link" [queryParams]="sr.actionLinks.params">{{ sr.actionLinks.text }}</a>
                          }
                          @if (sr.actionLinks && !sr.actionLinks.params) {
                            <a [routerLink]="sr.actionLinks.link">{{ sr.actionLinks.text }}</a>
                          }
                        </div>
                      </se-fe-header>
                    </se-fe-list-item>
                  }
                </se-fe-list>
              </div>
            </div>
            @if (pageMetadata.pagination && !pageMetadata.pagination.last_page) {
              <div pl-grid-el pl-grid="shrink@phone"
                >
                <se-fe-button [seFeDataIsLoading]="loadingMore" seFeDataEmphasis="low" (click)="loadMore()">
                  <span>{{ 'REGISTRATIONS.see_older_registrations' | translate }}</span>
                </se-fe-button>
              </div>
            }
          </div>
        }
      </div>
    </div>
  }
</div>
